export const GET_PROCEDURE_DETAILS_BY_ID =
  "/doctor/get-procedure-details-by-procedure-id";
export const GET_MULTIPLE_PAYMENT_LIST = "/api/v1/get_offline_payment_details/";
export const ADD_MULTIPLE_PAYMENTS = "/api/v1/add_offline_payment_details/";
export const GET_RESOURCE_PROCEDURE_LIST = "/clinic/get-lab-proedure";
export const GET_RECEIPT_DETAILS_BY_ID = "/doctor/get-receipt-details-by-id";
export const GET_EDIT_RECEIPT_DETAILS_BY_ID =
  "/doctor/get-edit-receipt-details-by-id";
export const EDIT_RESOURCE_INVOICE = "/api/v3/resource-edit-invoice";
export const RAISE_RESOURCE_INVOICE = "/api/v3/resource-raise-invoice";
